import { render, staticRenderFns } from "./OrganizationalStructureMenu.vue?vue&type=template&id=6228ba2e"
import script from "./OrganizationalStructureMenu.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructureMenu.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalStructureMenu.vue?vue&type=style&index=0&id=6228ba2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports